import FirmDetails from '../src/FirmDetails.tsx';
export default FirmDetails;
